<div class="alert alert-success" *ngIf="bluechatActivated">
    <i class="fa fa-comments m-r-xs"></i>
    <span [i18n]="'bluechat.activated'"></span>
</div>
<div class="alert alert-warning" *ngIf="!bluechatActivated">
    <i class="fa fa-comments m-r-xs"></i>
    <span [i18n]="'bluechat.deactivated'"></span>
</div>
